module.exports = __webpack_public_path__ + "a1f7b38fecbcef723829df8d9bb14fb6.svg";